import { FormattedMessage } from "react-intl";
import { useParams } from "react-router-dom";

import { useGetQuoteRequestDetails } from "api/queries/quotes/useGetQuoteRequestDetails";

export default function EditScheduleMultistopSidebar() {
  const id = useParams().id?.toUpperCase()!;
  useGetQuoteRequestDetails({
    shipmentId: id,
  });

  return (
    <div>
      <h6>
        <FormattedMessage id="tracking.components.editScheduleDialog.editSchedule" defaultMessage="Edit schedule" />
      </h6>
    </div>
  );
}
